<template>
  <header class="header">
    <div class="container">
      <div class="header__row row">
        <div class="header__logo logo col-12 col-md-1 col-lg-1">
          <router-link to="/"  class="logo__link">
            <img :src="logo" alt="Logo Arus" class="logo__img">
            <img :src="logo_mob" alt="Logo Arus" class="logo__img-mob">
          </router-link>
        </div>
        <div class="col-5 offset-0 col-md-3 offset-md-3 col-lg-2 offset-lg-4"></div>
        <div class="col-7 col-md-5 col-lg-5">
          <form class="header__form-search"   @submit="onSubmit">
            <input
              v-model="input"
              name="search" placeholder="Tx/address/token name" type="search">
            <button @click="onSearch" type="submit">
              <img :src="search" alt="Search">
            </button>
          </form>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import logo from './../../assets/images/icon/logo.svg';
  import logo_mob from './../../assets/images/icon/logo_mob.svg';

  import search from './../../assets/images/icon/search.svg'
  export default {
    name: 'Header',
    data: function () {
      return {
        logo,
        input: '',
        search,
        logo_mob
      };
    },
    methods: {
      onSearch(e) {
        e.preventDefault();
        this.input = this.input.replace(/-/g,'');
        if (this.input.length === 64) {
          this.$router.push('/tx/' + this.input);
        } else if (this.input.length === 40) {
          this.$router.push('/address/' + this.input + '/tx/1');
        } else {
          this.$router.push('/transactions/' + this.input + '/tx/1');
        }
      }
    }
  };
</script>

